import { render, staticRenderFns } from "./userOrders.vue?vue&type=template&id=880c3ed6"
import script from "./userOrders.vue?vue&type=script&lang=js"
export * from "./userOrders.vue?vue&type=script&lang=js"
import style0 from "./userOrders.vue?vue&type=style&index=0&id=880c3ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports